import React from "react";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "sonner";
import AppRouter from "./app/routes/index.jsx";
import ErrorBoundary from "./components/ErrorBoundary.jsx";
import { store } from "./app/store.js";
import { Provider } from "react-redux";
import AuthInitializer from "./components/AuthInitializer.jsx";

function App() {
  return (
    <ErrorBoundary>
      <Provider store={store}>
        <AuthInitializer>
          <BrowserRouter>
            <AppRouter />
            <Toaster position="top-right" richColors closeButton />
          </BrowserRouter>
        </AuthInitializer>
      </Provider>
    </ErrorBoundary>
  );
}

export default App;
